
import { useEffect } from "react";
import { useNavigate, useLocation, useSearchParams } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { useUserRole } from "@/hooks/useUserRole";
import HeroSection from "@/components/HeroSection";
import FeaturesSection from "@/components/FeaturesSection";
import HowItWorks from "@/components/HowItWorks";
import TestimonialsSection from "@/components/TestimonialsSection";
import StatsSection from "@/components/StatsSection";
import CTASection from "@/components/CTASection";

const Index = () => {
  const { user } = useAuth();
  const { isAdmin, loading } = useUserRole();
  const navigate = useNavigate();
  const location = useLocation();
  const [searchParams] = useSearchParams();

  // Capture referral code from URL and store in localStorage
  useEffect(() => {
    const refCode = searchParams.get("ref");
    if (refCode) {
      localStorage.setItem("referral_code", refCode);
      console.log("Referral code captured:", refCode);
    }
  }, [searchParams]);

  useEffect(() => {
    // Check if navigation came from navbar click
    const fromNavbar = location.state?.fromNavbar;
    
    // Only redirect if user is authenticated, role loading is complete, user is admin,
    // and navigation did NOT come from navbar click
    if (user && !loading && isAdmin && !fromNavbar) {
      navigate("/admin-dashboard");
    }
  }, [user, isAdmin, loading, navigate, location.state]);

  return (
    <div className="min-h-screen bg-background">
      <HeroSection />
      <FeaturesSection />
      <HowItWorks />
      <TestimonialsSection />
      <StatsSection />
      <CTASection />
    </div>
  );
};

export default Index;
